document.addEventListener('click', event => {
  const button = event.target.closest('[data-ox-quantity]');
  if (!button || button.disabled || button.hidden) return;
  const section = button.closest('.product-information');
  const input = section?.querySelector('input[name="quantity"]');
  if (!input) return;
  const quantity = Number(button.dataset.oxQuantity);
  if (input.max && quantity > Number(input.max)) return;
  input.value = String(quantity);
  input.dispatchEvent(new Event('input', {bubbles:true}));
  input.dispatchEvent(new Event('change', {bubbles:true}));
  section.querySelectorAll('[data-ox-quantity]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
});
document.addEventListener('change', event => {
  if (!event.target.matches('input[name="quantity"]')) return;
  const section = event.target.closest('.product-information');
  section?.querySelectorAll('[data-ox-quantity]').forEach(item => item.setAttribute('aria-pressed', String(Number(item.dataset.oxQuantity) === Number(event.target.value))));
});
(() => {
  let scheduled = false;
  const syncOffers = () => {
    scheduled = false;
    document.querySelectorAll('.product-information').forEach(section => {
      if (!section.querySelector('[data-ox-quantity="5"]')) return;
      const input = section.querySelector('input[name="quantity"]');
      if (!input) return;
      const stock = section.querySelector('[data-ox-offer-stock]');
      const inventoryMaximum = stock ? Math.max(0, Number(stock.dataset.oxOfferStock)) : Infinity;
      const quantityMaximum = input.max === '' ? Infinity : Number(input.max);
      const maximum = Math.min(inventoryMaximum, quantityMaximum);
      if (maximum > 0 && Number(input.value) > maximum) {
        input.value = String(maximum);
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      section.querySelectorAll('[data-ox-quantity]').forEach(button => {
        const unavailable = Number(button.dataset.oxQuantity) > maximum;
        button.hidden = unavailable;
        button.style.display = unavailable ? 'none' : '';
        button.disabled = unavailable;
        if (unavailable) button.setAttribute('aria-pressed', 'false');
      });
    });
  };
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(syncOffers);
  };
  const start = () => {
    syncOffers();
    new MutationObserver(schedule).observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['max', 'data-ox-offer-stock']
    });
  };
  document.addEventListener('change', schedule);
  document.addEventListener('input', schedule);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
